import Icon from '../components/Icon.vue'

Icon.register({"laptop":{"width":640,"height":512,"paths":[{"d":"M512 64V320H128V64H512M528 0H112C85.5 0 64 21.5 64 48V336C64 362.5 85.5 384 112 384H528C554.5 384 576 362.5 576 336V48C576 21.5 554.5 0 528 0zM628 416H389.5C386.5 416 384 418.1 383.6 421.1 381.2 436.3 368 448 352 448H288C272 448 258.8 436.3 256.4 421.1 255.9 418.2 253.4 416 250.5 416H12C5.4 416 0 421.4 0 428V464C0 490.5 21.5 512 48 512H592C618.5 512 640 490.5 640 464V428C640 421.4 634.6 416 628 416z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/laptop.js
// module id = u73F
// module chunks = 0